export default __webpack_public_path__ + "static/media/BMWGroupCondensed-Bold.1b980dee.woff2";